export const styles = {
  paper: (theme) => ({
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.black,
    borderRadius: 2,
    p: 1,
  }),
  title: (theme) => ({
    color: theme.palette.common.black,
    pb: 1,
  }),
  content: (theme) => ({
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.black,
  }),
  text: (theme) => ({
    whiteSpace: "pre-line",
    color: theme.palette.common.black,
  }),
  actions: {
    pt: 0,
    px: 3,
    pb: 1,
  },
  acceptButton: (theme) => ({
    backgroundColor: theme.palette.primary.blue,
    color: theme.palette.common.white,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.darkBlue,
    },
  }),
}
